<template>
    <v-container v-if="isAdminOrCompanyCoordinator" fluid class="px-10 export-container" id="export">
        <h1 class="mb-5">Exports </h1>
        <div class="export-container">
            <v-card v-if="config.hasStorage" class="download-card">
                <v-card-title>
                    <v-icon color="#9F2B68">mdi-warehouse</v-icon>Υλικά στην Αποθήκη
                </v-card-title>
                <v-select
                    v-model="selectedClient"
                    :items="clients"
                    clearable
                    return-object
                    item-text="name"
                    label="Πάροχος"
                    class="field mx-4"
                ></v-select>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :loading="loading"
                        @click="exportMaterials"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="config.hasStorage" class="download-card">
                <v-card-title>
                    <v-icon color="#9F2B68">mdi-warehouse</v-icon>Χρησιμοποιημένα Υλικά
                </v-card-title>
                <v-select
                    v-model="selectedClient2"
                    :items="clients"
                    clearable
                    return-object
                    item-text="name"
                    label="Πάροχος"
                    class="field mx-4"
                ></v-select>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :loading="loading2"
                        @click="exportUsedMaterials"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>
<script>
    import jwtUtil from '@/utils/jwtUtil'
    import materialService from '@/services/material'
    import Alert from '@/components/Alert'
    import client from '@/services/client'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { Alert },
        data() {
            return {
                clients: [],
                selectedClient: null,
                selectedClient2: null,
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                loading2: false
            }
        },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            userContractor() {
                return this.$store.getters.getUserContractor || ''
            },
            isAdminOrCompanyCoordinator() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles) || (this.containsAny(['ROLE_COORDINATOR'], this.userRoles) && this.userContractor.toLowerCase() === COMPANY_NAME.toLowerCase())
            }
        },
        created() {
            client.getAllClients().then(resp => {
                this.clients = resp.data
            })
        },
        methods: {
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            exportMaterials() {
                this.loading = true
                materialService.exportMaterials(this.selectedClient ? this.selectedClient.id : null).then(resp => {
                    this.downloadFile(resp.data, 'Materials' + (this.selectedClient ? ` - ${this.selectedClient.name}` : ' - General'))
                    this.selectedClient = null
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                    this.loading = false
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            exportUsedMaterials() {
                this.loading2 = true
                materialService.exportUsedMaterials(this.selectedClient2 ? this.selectedClient2.id : null).then(resp => {
                    this.downloadFile(resp.data, 'Used Materials' + (this.selectedClient2 ? ` - ${this.selectedClient2.name}` : ' - General'))
                    this.selectedClient2 = null
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                    this.loading2 = false
                }).catch((error) => {
                    this.loading2 = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            downloadFile(fileData, fileName) {
                const data = 'text;charset=utf-8,' + encodeURIComponent(fileData)
                const link = document.createElement('a')
                link.href = 'data:' + data
                link.download = `${fileName}.csv`

                const container = document.getElementById('export')
                container.appendChild(link)
                link.click()
            }

        }
    }
</script>
<style scoped>
.export-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.download-card {
    width: 30%;
    max-width: 350px;
    padding: 1rem;
}

.export-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>
